import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/profile/_components/HistoryHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/profile/_components/HistoryWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KYCAlertBanner"] */ "/app/src/components/shared/KYCAlertBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LockedAccountBanner"] */ "/app/src/components/shared/LockedAccountBanner/index.tsx");
